<!--The content below is only a placeholder and can be replaced.-->
<div id="main-content">
    <div class="container-fluid" style="overflow:hidden;">
        <div class="row">
            <div class="col-12">
                <app-header></app-header>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="p-3"></div>
            </div>
        </div>

        <div class="row" id="current-route-content">
            <div class="col-12">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
    <app-debugcontrols></app-debugcontrols>
    <app-pwa-installer></app-pwa-installer>
</div>

